import { IVendorEntityModel } from '../../../../../../service/vendor/entity/IVendorEntityModel';
import { RowContextMenuUI } from '../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuUI';
import { DefaultRowContextMenu } from '../../../../../design/dataTable/parts/rowContextMenu/view/DefaultRowContextMenu';

export class VendorEntityContextMenuUI<RowType> extends RowContextMenuUI<IVendorEntityModel> {
  constructor(contextDomain) {
    super(contextDomain);
    this.defaultContextMenu.setValue({
      Component: DefaultRowContextMenu,
      id: 'default',
      properties: {
        event: null,
        isOpened: false,
        row: null,
      },
    });
  }
}
